import AGENTES from "../../utils/agentes";
import { getPartnerConfig } from "../../config/partners";

function getUrlParamsAndStorageInfo(urlParams) {
  const source = urlParams.get("utm_source");
  const medium = urlParams.get("utm_medium");

  const partnerConfig = getPartnerConfig(source, medium);
  const partnerToken = partnerConfig
    ? urlParams.get(partnerConfig.tokenParam) || urlParams.get("ut")
    : null;

  const campaign = urlParams.get("utm_campaign");
  const deeplink = urlParams.get("deeplink");
  const content = urlParams.get("utm_content");
  const token = urlParams.get("token");
  const qs = urlParams.get("qs");
  const puid = urlParams.get("puid");
  const vuid = urlParams.get("vuid");
  const disableDeepLinkParam = urlParams.get("disableDeepLink");
  const productsAvailable = urlParams.getAll("prd_avl");
  const vehicleTypeParam = urlParams.get("vType");
  const isWowUser = urlParams.get("utm_campaign") === AGENTES.WOW;
  const docRef = localStorage.getItem("docRef");
  const currentVehicle = localStorage.getItem("currentVehicle");

  /// USER PARAMS
  let param_gender = urlParams.get("gender");
  let param_birthDay = urlParams.get("birthDay");
  let param_birthMonth = urlParams.get("birthMonth");
  let param_birthYear = urlParams.get("birthYear");
  let param_civilStatus = urlParams.get("civilStatus");
  let param_zipCode = urlParams.get("zipCode");
  let param_isInsured = urlParams.get("isInsured");
  let param_iDay = urlParams.get("iDay");
  let param_iMonth = urlParams.get("iMonth");
  let param_iYear = urlParams.get("iYear");
  let param_iType = urlParams.get("iType");
  let param_name = urlParams.get("name");
  let param_firstName = urlParams.get("firstName");
  let param_lastName = urlParams.get("lastName");
  let param_lastName2 = urlParams.get("lastName2");
  let param_phone = urlParams.get("phone");
  let param_rank = urlParams.get("rank");
  let param_email = urlParams.get("email");
  let param_rfc = urlParams.get("rfc");
  let param_uid = urlParams.get("uid");

  /// VEHICLE PARAMS
  let param_type = urlParams.get("type");
  let param_brand = urlParams.get("brand");
  let param_year = urlParams.get("year");
  let param_model = urlParams.get("model");
  let param_version = urlParams.get("version");
  let param_vStatus = urlParams.get("vStatus");
  let param_premium = urlParams.get("premium");
  let param_period = urlParams.get("period");
  let param_cluppId = urlParams.get("cluppId");

  return {
    source,
    medium,
    campaign,
    deeplink,
    content,
    token,
    partnerConfig,
    partnerToken,
    qs,
    puid,
    vuid,
    disableDeepLinkParam,
    vehicleTypeParam,
    productsAvailable,
    isWowUser,
    docRef,
    currentVehicle,
    userParams: {
      param_gender,
      param_birthDay,
      param_birthMonth,
      param_birthYear,
      param_civilStatus,
      param_zipCode,
      param_isInsured,
      param_iDay,
      param_iMonth,
      param_iYear,
      param_iType,
      param_name,
      param_firstName,
      param_lastName,
      param_lastName2,
      param_phone,
      param_rank,
      param_email,
      param_rfc,
      param_uid,
    },
    vehicleParams: {
      param_type,
      param_brand,
      param_year,
      param_model,
      param_version,
      param_vStatus,
      param_premium,
      param_period,
      param_cluppId,
    },
  };
}

export default getUrlParamsAndStorageInfo;
